function openSizeGuide() {
  document.getElementById('sizeGuideModal').style.display = 'block';
  document.body.style.overflow = 'hidden';
}

function closeSizeGuide() {
  document.getElementById('sizeGuideModal').style.display = 'none';
  document.body.style.overflow = 'auto';
}

// Cerrar modal al hacer clic fuera de él
window.onclick = function(event) {
  const modal = document.getElementById('sizeGuideModal');
  if (event.target === modal) {
    closeSizeGuide();
  }
}

// Cerrar modal con la tecla Escape
document.addEventListener('keydown', function(event) {
  if (event.key === 'Escape') {
    closeSizeGuide();
  }
});

// Función simple para abrir y cerrar el modal
function openSizeGuide() {
  document.getElementById('sizeGuideModal').style.display = 'block';
  document.body.style.overflow = 'hidden';
}

function closeSizeGuide() {
  document.getElementById('sizeGuideModal').style.display = 'none';
  document.body.style.overflow = 'auto';
}

// Cerrar modal al hacer clic fuera de él
window.onclick = function(event) {
  const modal = document.getElementById('sizeGuideModal');
  if (event.target === modal) {
    closeSizeGuide();
  }
}

// Cerrar modal con la tecla Escape
document.addEventListener('keydown', function(event) {
  if (event.key === 'Escape') {
    closeSizeGuide();
  }
});

// Ocultar iconos de play cuando se reproduzcan los videos
document.addEventListener('DOMContentLoaded', function() {
  // Esperar un poco para que Shopify renderice los videos
  setTimeout(function() {
    const videoOverlays = document.querySelectorAll('[data-video-overlay]');
    
    videoOverlays.forEach(overlay => {
      // Buscar el video más cercano
      const video = overlay.parentElement.querySelector('video');
      
      if (video) {
        // Hacer clic en el overlay (pero no en el icono) para reiniciar y pausar
        overlay.addEventListener('click', function(e) {
          // Solo si no se hizo clic en el icono de play
          if (!e.target.closest('.play-icon-circle')) {
            e.stopPropagation();
            video.currentTime = 0; // Reiniciar al inicio
            video.pause(); // Pausar el video
            overlay.classList.remove('hidden'); // Mostrar el overlay
          }
        });
        
        // Hacer clic específico en el icono de play
        const playIcon = overlay.querySelector('.play-icon-circle');
        if (playIcon) {
          playIcon.addEventListener('click', function(e) {
            e.stopPropagation();
            video.play(); // Reproducir el video
          });
        }
        
        // Hacer clic en el video para reproducir
        video.addEventListener('click', function() {
          if (video.paused) {
            video.play();
          } else {
            video.pause();
          }
        });
        
        // Ocultar overlay cuando el video se reproduce
        video.addEventListener('play', function() {
          overlay.classList.add('hidden');
        });
        
        // Mostrar overlay cuando el video se pausa
        video.addEventListener('pause', function() {
          overlay.classList.remove('hidden');
        });
        
        // Mostrar overlay cuando el video termina
        video.addEventListener('ended', function() {
          overlay.classList.remove('hidden');
        });
      }
    });
  }, 1000); // Esperar 1 segundo para que Shopify renderice
}); 